import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../global/config/store';
import { ReactElement } from 'react';

interface ProtectedOtpRouteProps {
    children: React.ReactNode;
}

const ProtectedOtpRoute = ({ children }: ProtectedOtpRouteProps): ReactElement => {
    const canAccessOtp = useSelector((state: RootState) => state.auth.canAccessOtp);

    if (!canAccessOtp) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default ProtectedOtpRoute;